
<div class="card">
    <div class="card-header">
      <h4>Risk Report</h4>
    </div>
    <div class="card-body m-0">
      <div class="row mb-2">
        <div class="col-xl-10">
         
          <button type="button" class="btn bg-danger-custom" (click)="onExportCSV()">
            Export Excel<i class="feather icon-download"></i></button>
          <button type="button" class="btn bg-danger-custom" 
            (click)="quickFilterShowAction($event)">Quick Filters<i class="feather icon-filter"></i></button>
          <div class="btn-group mb-1 mb-md-0">
           
            <div class="btn-group" ngbDropdown role="group">
              <button class="btn bg-danger-custom" ngbDropdownToggle>Columns</button>
              <div ngbDropdownMenu class="ng-dropdown-panel-items p-1"
                style="height: 250px;width: 250px; overflow: scroll; scroll-behavior: smooth">
                <div class="form-group">
                  <div *ngIf="columnDefs" class="list-group ng-option">
                    <span *ngFor="let column of columnDefsCopy; let i = index" class="checkbox">
                      <label class="list-group-item p-2">
                        <input class="form-check-input me-1" type="checkbox" value="{{i}}" name="{{column.headerName}}"
                          (change)="updateSelectedColumn($event)"
                          [checked]="(tableSelectedColumn && (-1 !==tableSelectedColumn.indexOf(column)) ? 'checked': '')" />
                        {{(column?.headerName?.replace('_','') || column?.field?.replace('_','') ) }}
                      </label>
                    </span>
                  </div>
  
                </div>
                <!--          <ng-select-->
                <!--            [(ngModel)]="tableSelectedColumn"-->
                <!--            [closeOnSelect]="false"-->
                <!--            [items]="columnDefs"-->
                <!--            [multiple]=true-->
                <!--            bindLabel="field">-->
                <!--            <ng-template let-index="index" let-item="item" let-item$="item$" ng-option-tmp>-->
                <!--              <input [ngModel]="item$.selected" id="item-{{index}}" type="checkbox"/> {{item.field.toUpperCase()}}-->
                <!--            </ng-template>-->
                <!--          </ng-select>-->
  
              </div>
            </div>
          </div>
        </div>
        <!-- <div class="col-xl-2" *ngIf="permissions.includes('View')">
          <input id="typeahead-basic" type="text" autocomplete="new-password" placeholder="Search in page"
            class="form-control" (selectItem)="searchQuickFilter($event)" [(ngModel)]="globalSearch"
            (ngModelChange)="onGlobalSearchChange($event)" [ngbTypeahead]="search" />
        </div> -->
      </div>
  
  
  
      
      <div *ngIf="quickFilterShow" class="row" style="min-height: 100px">
      
  
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-4">
                  <!-- <div class="row"> -->
                  <label class="col-form-label">Search by Business Category</label>
                 
                  <!-- <ng-select    [(ngModel)]="searchMerName" 
                  maxlength="50" id="searchMerName"
                    
                    (change)="onselectBusinessCat($event)" >
                    <ng-option *ngFor="let categoryType of categoryTypeOptions" [value]="categoryType.id">
                      {{categoryType?.bussinessCategories}}
                    </ng-option>
                  </ng-select>  -->
  
               
  
  
  
  
                </div>
                <div class="col-md-4">
                  <!-- <div class="row"> -->
                  <label class="col-form-label" >Search by Business Sub-Category</label>
                  <!-- <div class="col-md-8"> -->
  
                  <!-- <input (keyup.enter)="onSearchBtnClick($event)" [(ngModel)]="searchMID" class="form-control"
                  id="searchMID" maxlength="10" (keyup)="allowAlfanumeric($event)" (change)="allowAlfanumeric($event)"
                  type="text" autocomplete="new-password" /> -->
  
                  <!-- <ng-select #subCategorySearch  (change)="onselectBusinessSubCat($event)" [(ngModel)]="searchMID" 
                  id="searchMID" maxlength="10" >
                    <ng-option *ngFor="let subCategory of subCategoryTypeOptions" [value]="subCategory.id">
                      {{subCategory?.bussinessSubCategories}} 
                    </ng-option>
                  </ng-select> -->
  
  
                
                </div>
  
                <div class="col-md-4">
  
                  <label class="col-form-label" for="resellerPartnerId">Search by Risk Level Code</label>             
           
                  
                  
                  
                  <!-- <ng-select #risksearch  (change)="onselectRiskLevelCode($event)" 
                  id="resellerPartnerId" maxlength="10" >
                    <ng-option *ngFor="let riskcodevalue of riskcode" [value]="riskcodevalue?.value">
                      {{riskcodevalue?.code}} 
                    </ng-option>
                  </ng-select> -->
  
                </div>
  
              </div>
  
  
            
  
  
            </div>
          </div>
        
      </div>
  
      <div class="row mb-0" style="min-height: 470px">
        <div class="col-12 col-xl-12 grid-margin stretch-card ag-theme-alpine" style="margin-bottom: 0px">
          <ag-grid-angular  [rowData]="rowData" (gridReady)="onGridReady($event)"    [defaultColDef]="defaultColDef" [columnDefs]="tableSelectedColumn" [enableCellTextSelection]=true (sortChanged)="onSortChange($event)"
            (filterChanged)="onFilterChange($event)" (filterModified)="onFilterModified($event)"
            (filterOpened)="onFilterOpened($event)"  (rowClicked)="onRowClicked($event)"
            (rowDoubleClicked)="onRowDoubleClicked($event)" (search)="globalSearch" 
          [paginationPageSize]="pageSize"
            [pagination]="true"  [rowSelection]="'single'"
            [suppressPaginationPanel]="true" style="width: 100%; height: auto;">
          </ag-grid-angular>
  
          
        </div>
      </div>
      <div class="row mt-0">
        <div class="col-4 col-xs-4">
          <!-- <select (change)="onPageSizeChanges($event)" [(ngModel)]="pageSize"
            class="form-select d-flex justify-content-end col-4" name="pageSize" style="width: auto">
           
            <option *ngFor="let pageNum of pageSizeArr" [ngValue]="pageNum">{{pageNum}}</option>
  
          </select> -->
        </div>
  
        <div class="col-8 col-xs-8">
          <!-- <ngb-pagination (pageChange)="onPaginationChange($event)" [(page)]="currentPage" [boundaryLinks]="true"
            [collectionSize]="collectionSize" [maxSize]="maxSize" [pageSize]="pageSize" [rotate]="true"
            [ellipses]="ellipses" size="sm" class="d-flex justify-content-end align-right">
          </ngb-pagination> -->
        </div>
  
      </div>
    </div>
  
  </div>